// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"67":"1e95f6b8","165":"10be62f0","195":"f23c1c82","313":"5520db36","379":"38eb3ce9","453":"bf246a7b","609":"1c8c9a24","796":"4ed2d9dd"}[chunkId] + ".chunk.js";
};